import React, { useRef, useEffect } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { FormikInput } from "./index";

const PhoneInputField = ({
  formikProps,
  disabled,
  disableComponent,
  ...props
}) => {
  const phoneInputRef = useRef(null);

  useEffect(() => {
    if (phoneInputRef.current) {
      const dropdownButton = phoneInputRef.current.dropdownContainerRef;

      if (dropdownButton) {
        const handleDropdownClick = () => {
          const currentPhoneCode = formikProps.values.phoneCode || "+92";
          formikProps.setFieldValue("phone", currentPhoneCode);
          formikProps.setFieldValue("phoneNum", "");
        };

        dropdownButton.addEventListener("click", handleDropdownClick);
        return () => {
          dropdownButton.removeEventListener("click", handleDropdownClick);
        };
      }
    }
  }, [formikProps]);

  return (
    <div style={{ marginBottom: "0px" }}>
      <label
        style={{
          color: "#999",
          marginBottom: "4px",
          display: "block",
          fontSize: "14px",
        }}
      >
        Phone *
      </label>
      {disabled ? (
        <FormikInput formikProps={formikProps} disabled={true} />
      ) : disableComponent ? (
        <PhoneInput
          ref={phoneInputRef}
          disabled={true}
          inputProps={{
            name: "ph",
            required: true,
            readOnly: true,
          }}
          value={formikProps.values.phone}
          inputStyle={{
            width: "100%",
            backgroundColor: "#2d2d2d",
            color: "#ffffff",
            border: "1px solid #3d3d3d",
            cursor: "not-allowed",
            height: "32px",
            fontSize: "16px",
          }}
          buttonStyle={{
            display: "none",
          }}
          placeholder=""
          {...props}
        />
      ) : (
        <div>
          <PhoneInput
            ref={phoneInputRef}
            country={"pk"}
            inputProps={{
              name: "phoneNum",
              required: true,
            }}
            value={formikProps.values.phone}
            onChange={(value, countryData) => {
              const phoneCode = `+${countryData.dialCode}`;
              const phoneNum = value.replace(countryData.dialCode, "").trim();
              formikProps.setFieldValue("phoneCode", phoneCode);
              formikProps.setFieldValue("phoneNum", phoneNum);
              formikProps.setFieldValue("phone", value);
            }}
            inputStyle={{
              width: "100%",
              fontSize: "16px",
              padding: "4px",
              paddingLeft: "48px",
              backgroundColor: "#2d2d2d",
              color: "#ffffff",
              border: "1px solid #3d3d3d",
              borderRadius: "4px",
              height: "auto",
            }}
            buttonStyle={{
              border: "none",
              backgroundColor: "transparent",
              borderRadius: "4px 0 0 4px",
              padding: "0 6px",
            }}
            containerStyle={{
              width: "100%",
            }}
            dropdownStyle={{
              backgroundColor: "#2d2d2d",
              color: "#ffffff",
              border: "1px solid #3d3d3d",
            }}
            placeholder="3081234567"
            {...props}
          />
          <style>{`
            .react-tel-input .form-control {
              padding-left: 48px !important;
            }
            .react-tel-input .selected-flag {
              background-color: #2d2d2d !important;
              border-radius: 4px 0 0 4px !important;
            }
            .react-tel-input .selected-flag:hover,
            .react-tel-input .selected-flag:focus {
              background-color: #3d3d3d !important;
            }
            .react-tel-input .country-list {
              background-color: #2d2d2d !important;
              color: #ffffff !important;
            }
            .react-tel-input .country-list .country:hover {
              background-color: #3d3d3d !important;
            }
            .react-tel-input .country-list .country.highlight {
              background-color: #3d3d3d !important;
            }
          `}</style>
        </div>
      )}
      {formikProps.errors.phone && formikProps.touched.phone && (
        <div
          style={{
            color: "#ff4d4d",
            fontSize: "12px",
            marginTop: "5px",
          }}
        >
          {formikProps.errors.phone}
        </div>
      )}
    </div>
  );
};

export default PhoneInputField;
